import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "bcms-react";
import TemplateDetailsPage, { getDefaultData, getDefaultUI } from 'components/pages/TemplateDetailsPage';
import TemplatesACHPage from "components/pages/TemplatesACHPage";
import Classes, { ACHFromAccount, Account, Participant, ACHToParticipant, ACHTemplate, Company } from "model";

export default function CaptureTemplateDetailsNewTemplateDisplayed(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const achFromAccount = ACHFromAccount.init({ account: Account.initByID(5).id, id: ACHFromAccount.nextID() });
  const defaultData = getDefaultData();

  let achToParticipants = defaultData.achToParticipants.participants;
  let nextID = undefined;
  if (achToParticipants.length === 0) {
    nextID = ACHToParticipant.nextID();
  } else {
    nextID = achToParticipants.length;
  }
  const participants = Participant.initAll().map(item => {
    // "isSelected" will be used to keep track of row selection.
    item.isSelected = "true";
    return item;
  }).filter(item => {
    return item.group === "Employee";
  });
  const updatedACHToParticipants = participants.reduce((acc, item) => {
    if (item.isSelected === "true") {
      const added = ACHToParticipant.init({
        id: nextID, participant: item.id,
        oneTimeACHPayment: defaultData.oneTimeACHPayment, notify: "No", addenda: "0", numberOfDistributions: "2" 
      });
      nextID = parseFloat(nextID) + 1;
      acc.push(added);
    }
    return acc;
  }, []);

  achToParticipants = [...updatedACHToParticipants, ...achToParticipants];

  const addedAchTemplate = ACHTemplate.init({
    id: ACHTemplate.nextID(),
    transactionType: "payment",
    secCode: "PPD Credit - Consumer Credit",
    name: "New Payroll",
    companyDiscretionaryData: "Bi-Weekly",
    companyEntryDescription: "Payroll",
    creditAmount: "0.00",
    debitAmount: "0.00",
    achToParticipants: achToParticipants,
    achFromAccount: [achFromAccount],
    company: Company.initByID(0),
    numberOfAccounts:"0"
  });

  const achTemplates = ACHTemplate.initAll()
  let mergeAchTemplates = [...achTemplates, addedAchTemplate];

  const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["achTemplates"], mergeAchTemplates)
    .update(["createdTemplate"], addedAchTemplate)
    .submit();

  const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update(["showCreatedACHTemplateBanner"], true)
    .submit();

  return (

    <TemplatesACHPage ui={ui} data={data} />
  )
}


